import React from "react";

/** Watches the container so a fixed-size drawing (certificate, birthday card) can scale to fit inside it. */
export function useFitScale(
  ref: React.RefObject<HTMLDivElement | null>,
  page: { width: number; height: number },
): number {
  const [scale, setScale] = React.useState(1);

  React.useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;
    const update = () => {
      const { width, height } = node.getBoundingClientRect();
      if (width <= 0) return;
      setScale(
        height > 0
          ? Math.min(width / page.width, height / page.height)
          : width / page.width,
      );
    };
    update();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(update);
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, page.width, page.height]);

  return scale;
}
